export const REFERENCE_TABLE = {
  YES_NO_IND: 'YesNoInd',
  SERVICE_STATUS: 'ServiceStatus',
  VEHICLE_SERVICE_TYPE: 'VehicleServiceType',
  DRIVER_SERVICE_TYPE: 'DriverServiceType',
  PAYMENT_STATUS: 'PaymentStatus',
  TRANSACTION_STATUS: 'TransactionStatus',
  SURVEY_QUESTIONS: 'SurveyQuestions',
  TEST_SCHEDULE_DISCOVERY_SOURCE: 'TestScheduleDiscoverySource',
  TIME_TAKEN: 'TimeTaken',
  RATING: 'Rating',
  OVERALL_OPINION: 'OverallOpinion',
  RELATIONSHIP: 'Relationship',
  STATES: 'States',
  COUNTIES: 'Counties',
  SUFFIX: 'Suffix',
  EMERGENCY_CONTACT_RELATIONSHIP: 'EmergencyContactRelationship',
  DIFFICULTY_RATINGS: 'DifficultyRating',
  DISCOVERY_SOURCE: 'DiscoverySource',
  SURVEY_SERVICES_TAKEN: 'SurveyServicesTaken',
  RENEWAL_METHOD: 'RenewalMethod',
  FUTURE_SERVICE: 'FutureService',
  VEHICLE_CATEGORY: 'VehicleCategory',
  PAGE_CONTENT: 'PageContent',
  RENEWAL_YEARS: 'RenewalYears',
  ID_TYPE: 'IdType',
  BASE_DONATIONS: 'BaseDonations',
  ALTERNATIVE_DONATIONS: 'AlternateDonations',
  RID_PREVERIFY_LOGIN_TYPES: 'RIDPreVerifyLoginType',
  NAVIGATION_LINKS: 'NavigationLinks',
  EYE_COLOR: 'EyeColor',
  ERRORS: 'Errors',
  VR_TRAILER_RENEWAL_YEARS: 'VRTRLRRENEWYRS',
  VR_DUPLICATE_COUNT: 'VRDUPCOUNT',
}
